import * as React from 'react'
import './searchSkeletonRows.scss'

interface SearchSkeletonRowsProps {
    // 'Still searching...' variant renders beneath stale results while a
    // newer query is in flight, so fewer rows keep the list calm.
    label?: string
    rowCount?: number
}

// Decorative — the footer status announces search progress to screen readers.
export function SearchSkeletonRows({ label = 'Searching...', rowCount = 3 }: SearchSkeletonRowsProps): JSX.Element {
    return (
        <div aria-hidden="true">
            <div className="global-search-section-label">{label}</div>
            {Array.from({ length: rowCount }, (_, row) => (
                <div key={row} className="global-search-row global-search-row-skeleton">
                    <div className="global-search-skeleton-icon" />
                    <div className="global-search-row-text">
                        <div className="global-search-skeleton-bar global-search-skeleton-title" />
                        <div className="global-search-skeleton-bar global-search-skeleton-subtitle" />
                    </div>
                </div>
            ))}
        </div>
    )
}
